<script setup lang="ts">

defineEmits<{
    (on: "edit-my-details"): void;
    (on: "show-quote-summary"): void;
}>();
</script>

<template>
    <div class="row mt-3 justify-content-between top-action-row gx-2">
        <div class="col-6 col-lg-3 float-start">
            <button
                id="btn-edit-my-details"
                type="button"
                class="mb-2 float-start btn btn-secondary col-12 top-action-btn"
                @click="$emit('edit-my-details')"
            >
                Edit my details
            </button>
        </div>
        <div class="col-6 col-lg-3 offset-lg-6 float-end">
            <button
                id="btn-quote-summary"
                data-toggle="modal"
                data-target="#oldQuotes"
                type="button"
                class="mb-2 float-end btn btn-secondary col-12 top-action-btn"
                @click="$emit('show-quote-summary')"
            >
                <span aria-hidden="true">Quote summary</span>
            </button>
        </div>
    </div>
</template>

<style scoped>
.top-action-btn {
    border-radius: 999px;
    min-height: 44px;
    font-weight: 700;
}

@media (max-width: 992px) {
    .top-action-row {
        margin-top: 0.75rem !important;
    }

    .top-action-btn {
        font-size: 0.95rem;
        padding-left: 0.5rem;
        padding-right: 0.5rem;
    }
}
</style>
